export type CompanyDepartmentSummary = {
    id: number;
    name: string;
    numberOfUsers: number;
 
    canUpdate: boolean;
    canDelete: boolean;
}

export function CompanyDepartmentSummary_normalize(companyDepartmentSummary: CompanyDepartmentSummary): CompanyDepartmentSummary {
    return {
        id: companyDepartmentSummary.id ?? 0,
        name: companyDepartmentSummary.name ?? "",
        numberOfUsers: companyDepartmentSummary.numberOfUsers ?? 0,
        canUpdate: companyDepartmentSummary.canUpdate ?? false,
        canDelete: companyDepartmentSummary.canDelete ?? false
    };
}